import { render } from "./GCEImage.vue?vue&type=template&id=482b1630"
import script from "./GCEImage.vue?vue&type=script&lang=js"
export * from "./GCEImage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__